import React from 'react';
import {
  FormControl,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

const styles = {
  checkboxContainer: {
    flex: 1,
  },
};

function BaseFeatureFlagCheckbox({
  checked, handleStatusChange, label, featureFlagType,
}) {
  return (
    <FormControl fullWidth>
      <FormControlLabel
        labelPlacement="start"
        sx={{ ml: 0 }}
        label={(
          <Typography style={styles.checkboxContainer}>
            {label}
          </Typography>
        )}
        control={(
          <Checkbox
            checked={checked}
            onChange={(e) => handleStatusChange(e.target.checked, featureFlagType)}
            style={{ height: 5 }}
            color="primary"
          />
        )}
      />
    </FormControl>
  );
}

BaseFeatureFlagCheckbox.defaultProps = {};
BaseFeatureFlagCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  handleStatusChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  featureFlagType: PropTypes.string.isRequired,
};

const FeatureFlagCheckbox = withRouter(BaseFeatureFlagCheckbox);
export { BaseFeatureFlagCheckbox, FeatureFlagCheckbox };
